import {Injectable, OnDestroy} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Actions, ofType} from '@ngrx/effects';
import {AuthActions, WindowRef} from '@spartacus/core';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import { map} from 'rxjs/operators';

import {AimoUserService} from '../user/aimo-user.service';

@Injectable({
    providedIn: 'root',
})
export class AimoSolrDebugInfoService implements OnDestroy {
    private subscriptions = new Subscription();
    solrDebugInfo;

    constructor(protected userService: AimoUserService,
                protected winRef: WindowRef,
                protected activatedRoute: ActivatedRoute,
                private actions$: Actions
    ) {
        this.subscriptions.add(
            this.actions$
                .pipe(ofType(AuthActions.LOGIN))
                .subscribe(() => (this.solrDebugInfoSubject = new BehaviorSubject<boolean>(false))),
        );
        this.activatedRoute.queryParams.subscribe(q => {
            if (q['solrDebugInfo'] !== undefined) {
                this.solrDebugInfoSubject.next(q['solrDebugInfo'] === 'true');
            }
        });
    }

    private solrDebugInfoSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    isSolrDebugInfoEnabled(): Observable<boolean> {
        return this.userService.get().pipe(
            map((user) => user?.solrDebugInfoEnabled),
        );
    }

    getSolrDebugInfo(): Observable<boolean> {
        return this.solrDebugInfoSubject.asObservable();
    }

    setSolrDebugInfoSelected(value: boolean): void {
        this.solrDebugInfoSubject.next(value);
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
